module.exports = __webpack_public_path__ + "static/media/store-close.54c27620.svg";